import React from "react";
import { useParams, Navigate } from "react-router-dom";
import EcosystemTopicPage from "../components/EcosystemTopicPage";
import { ECOSYSTEM_TOPICS } from "../config/ecosystemTopics";

/**
 * Generic catch-all route component for ecosystem sub-routes.
 * Reads the route params and renders the right topic from the config map.
 */
export default function EcosystemRoutePage({ topicKey: explicitKey }) {
  const params = useParams();
  // Path can be e.g. "wellness/sleep" or "families/parenting"
  const key = explicitKey || `${params.section || ""}/${params.topic || ""}`.replace(/^\/+|\/+$/g, "");
  const topic = ECOSYSTEM_TOPICS[key];
  if (!topic) {
    // Send unknown topics to the homepage rather than a 404 dead-end
    return <Navigate to="/" replace />;
  }
  return (
    <EcosystemTopicPage
      eyebrow={topic.eyebrow}
      title={topic.title}
      subtitle={topic.subtitle}
      image={topic.image}
      pillars={topic.pillars || []}
      editorial={topic.editorial || []}
      quotes={topic.quotes || []}
      reads={topic.reads || []}
      products={topic.products || []}
      relatedLinks={topic.relatedLinks || []}
      marketplaceTopic={topic.marketplaceTopic}
      marketplaceTitle={topic.marketplaceTitle}
      askDonnyPrompt={topic.askDonnyPrompt}
      testid={`ecosystem-${key.replace(/\//g, "-")}`}
    />
  );
}
